import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import { Article } from "@randajan/jet-react/dom/article";

import "./LandingPage.scss";
import { useBeam } from '@randajan/bifrost/client/react';
import { userBeam } from '../../config/bifrost';
import { LoginButton } from '../../frames/Account/LoginButton/LoginButton';
import { ProfileButton } from '../../frames/Account/ProfileButton/ProfileButton';


const md = "# Vítejte na Alternatif.cz\n\nAlternatif.cz je online výběr dámského oblečení – jednoduchý, přehledný a bez zbytečností.\n\nKaždý týden pro vás vybíráme několik pečlivě zvolených kousků, které nás zaujaly kvalitou, střihem nebo nápadem. Nenakupujete u nás – jen se inspirujete a kliknutím přejdete rovnou na web originálního prodejce.\n\n## Jak se vyznat v cenách\n\n  `$` dostupné  \n`$$` střední cenová kategorie  \n`$$$` kvalitnější a prémiové značky  \n\nMyslíme i na ženy, které se nevejdou do konfekčních tabulek – sekce **PLUS** je věnovaná kráskám s křivkami.\n\n> 🔒 Přístup do výběru mají pouze členové. Členství je časově omezené a po skončení se automaticky neprodlužuje.\n\n👉 Pokud hledáte styl, kvalitu a úsporu času, jste tu správně."

const LoginRequired = () => {
    return (
        <div className="LoginRequired">
            <span>
                Pro pokračování se musíš přihlásit
            </span>
            <LoginButton />
        </div>
    )
}

const SubRequired = () => {
    return (
        <div className="SubRequired">
            <span>
                Pro pokračování je potřeba aktivovat členství
            </span>
            <ProfileButton>Aktivovat členství</ProfileButton>
        </div>
    )
}

export const LandingPage = (props) => {
    const { } = props;

    const { data: user } = useBeam(userBeam);



    return (
        <Block level={0} className="LandingPage">
            <div className="content slab withShade">
                <Article src={md} />
                {!user ? <LoginRequired/> : !user?.subIsActive ? <SubRequired/> : null}
            </div>
        </Block>
    )
}
